import { render } from "./SegmentControl_icon.vue?vue&type=template&id=b3d43368"
import script from "./SegmentControl_icon.vue?vue&type=script&lang=js"
export * from "./SegmentControl_icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__